import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c22bad7a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")

  return (_openBlock(), _createBlock(_component_ConfirmDialog, {
    group: "isConfirm",
    isConfirm: _ctx.state.isConfirm
  }, _createSlots({ _: 2 }, [
    (_ctx.$slots.title)
      ? {
          name: "title",
          fn: _withId(() => [
            _renderSlot(_ctx.$slots, "title", {}, undefined, true)
          ])
        }
      : undefined,
    (_ctx.$slots.info)
      ? {
          name: "info",
          fn: _withId(() => [
            _renderSlot(_ctx.$slots, "info", {}, undefined, true)
          ])
        }
      : undefined
  ]), 1032, ["isConfirm"]))
})